"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('preview-close', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("g", null, _react.default.createElement("g", {
    transform: "translate(3.828427, 15.619262)",
    stroke: props.outStrokeColor,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin,
    strokeWidth: props.strokeWidth
  }, _react.default.createElement("path", {
    d: "M2.17157288,0.38073752 C2.80629169,1.60001442 3.76803281,2.73112128 4.99433248,3.73614732 C8.43259828,6.55401208 13.9505966,8.38073752 20.1715729,8.38073752 C26.3925492,8.38073752 31.9105475,6.55401208 35.3488133,3.73614732 C36.5751129,2.73112128 37.5368541,1.60001442 38.1715729,0.38073752"
  }), _react.default.createElement("path", {
    d: "M22.1845102,12.2444408 L30.1845102,12.2444408",
    transform: "translate(26.184510, 12.244441) rotate(75.000000) translate(-26.184510, -12.244441) "
  }), _react.default.createElement("path", {
    d: "M32.3535534,8.56271804 L40.3535534,8.56271804",
    transform: "translate(36.353553, 8.562718) rotate(45.000000) translate(-36.353553, -8.562718) "
  }), _react.default.createElement("path", {
    d: "M0,8.56271804 L8,8.56271804",
    transform: "translate(4.000000, 8.562718) rotate(-45.000000) translate(-4.000000, -8.562718) "
  }), _react.default.createElement("path", {
    d: "M10.1344656,12.2444408 L18.1344656,12.2444408",
    transform: "translate(14.134466, 12.244441) rotate(-75.000000) translate(-14.134466, -12.244441) "
  })))));
});

exports.default = _default;